import { jitsiLocalStorage } from '@jitsi/js-utils';
import { sha256 } from 'js-sha256';
import _ from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import logger from '../../app/logger';
import { apiKEY } from '../../base/config/constants';
import { setJWT, setJwtStorage } from '../../base/jwt';
import { JWT_STORAGE, SET_ACCESS_TOKEN } from '../../base/jwt/actionTypes';
import { fetchAxiosApi, setuserDetails } from '../../base/mtApi';
import { updateSettings } from '../../base/settings';
import { getBackendSafeRoomName } from '../../base/util';
import { isDomainWeborNative } from '../../base/util/checkOS';

declare var config: object;

/**
 * GetUserDetails.
 */
export default function GetUserDetails() {
    const dispatch = useDispatch();
    const [ , setUserd ] = useState(undefined);
    const [ , setLoginButton ] = useState(false);
    const isMounted = React.useRef(false);
    const state1 = useSelector(state => state['features/base/jwt']);

    const { userDetails, pregData } = useSelector(state => state['features/base/mtApi']);

    const userAccessToken = jitsiLocalStorage.getItem('accessToken');
    const roomName = getBackendSafeRoomName(useSelector(state => state['features/base/conference'].room));

    useSelector(state => state['features/base/connection']);

    const accesToknn = state1.accessToken ?? userAccessToken;

    const _clearInvalidAccessToken = () => {
        jitsiLocalStorage.removeItem('accessToken');
        dispatch({
            type: SET_ACCESS_TOKEN,
            accessToken: null
        });
        dispatch(updateSettings({
            accessToken: null
        }));
        dispatch(setuserDetails(undefined));
        dispatch(setJWT(null));
        dispatch(setJwtStorage(null));
    };

    useEffect(() => {
        const accesTokn = state1.accessToken ?? userAccessToken;

        if ((_.isNil(userDetails) && pregData && accesTokn) && isMounted.current === true) {

            const moement = moment().seconds(0)
                .milliseconds(0)
                .format('X');

            const mesh256 = sha256(`${apiKEY}:MH:${moement}`);

            const preRegObject = JSON.stringify({
                'client_id': config.MH_CLIENT_ID,
                'credentials': mesh256,
                ...isDomainWeborNative,
                'meeting_id': roomName
            });

            fetchAxiosApi('customer/user_details', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${state1.accessToken ?? userAccessToken}`
                },
                body: preRegObject
            }).then(response => {
                const responseStatus = response?.response?.status ?? response?.status ?? response?.code;

                if (responseStatus === 401) {
                    _clearInvalidAccessToken();

                    return;
                }

                // const isTrueGuest: boolean = Boolean(preRegData?.allow_guest === 1);
                // jwt extracted from response.data

                setUserd(response.data);

                // dispatch(participantDesignation(participantId, response?.data?.designation))

                if (response.success) {
                    setLoginButton(true);
                    dispatch({
                        type: SET_ACCESS_TOKEN,
                        accessToken: state1.accessToken ?? userAccessToken
                    });
                    const getJwt = response.data?.jwt;

                    if (!_.isEmpty(getJwt) && !state1?.jwt) {
                        dispatch({
                            type: JWT_STORAGE,
                            jwtData: getJwt
                        });
                    }
                } else {
                    jitsiLocalStorage.removeItem('accessToken');
                }

                dispatch(setuserDetails(response.data));
            })
            .catch(e => {
                logger.error('UserDetailsAPI failed', e);
            });

        }

        isMounted.current = true;

    }, [ accesToknn ]);

    return <></>;
}
